.empty {
  color: var(--color-text);
  padding: 0.75rem;
}

.list {
  margin-top: 1rem;
}
